<template>
  <div class="content">
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>产品信息</b></div>
      <el-row :gutter="20">  
        <el-col :span="7"><div class="search-area-div-text">产品名称：{{productInformationList.goodsName}}</div> </el-col> 
         <el-col :span="5"><div class="search-area-div-text">产品编码：{{productInformationList.goodsCode}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div-text">规格：{{productInformationList.goodsSpec}}</div> </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7"><div class="search-area-div-text">单位：{{productInformationList.unitStyle}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div-text">生产企业：{{productInformationList.producer}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div-text"> 装箱量：{{productInformationList.bigUnitQty}}</div> </el-col> 
      </el-row> 
    </div>
    <div class="button-area">
      <div class="w100f t-left mb15"><b>产品指导价</b> <span class="fontC-red">（该指导价目前仅用于理货功能）</span></div>
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add()">批量新增指导价</el-button>
      <!-- <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table
        :data="tableData"
        style="width: 100%;"
        row-key="guid"
        @selection-change="handleSelectionChange"
        border> 
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
                    <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                    </template>
        </el-table-column>
        <el-table-column prop="venue" label="省份" header-align="center" align="center"></el-table-column>
        <el-table-column prop="guidancePrice" label="当前指导价" header-align="center" sortable align="center">
              <template slot-scope="scope">{{scope.row.guidancePrice | numDigit | numFmt }}</template>
        </el-table-column>  
        <el-table-column prop="startTime" label="开始执行时间" header-align="center" sortable align="center">
                    <template slot-scope="scope">{{scope.row.startTime | getDate}}</template>
        </el-table-column> 
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(scope.row)">新增指导价 | </a>
            <a class="txt-color" @click="toLink(scope.row.province)">所有指导价</a> 
          </template>
        </el-table-column>
      </el-table> 
    </div>
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination> -->
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="128px"
        :label-position="right"
        class="demo-ruleForm"
      >
      <div class="mb15 font-S16" v-if="provinces != null && provinces != ''">已选择：{{provinces.length}}个省份</div>
        <el-form-item label="指导价:" prop="guidancePrice">
          <el-input v-model="ruleForm.guidancePrice" autocomplete="off" class="w100f" type="number"></el-input>
        </el-form-item>
        <el-form-item label="开始执行时间:" prop="startTime">
          <el-date-picker
            v-model="ruleForm.startTime"
            type="date"
            class="w100f"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        新的指导价到达“开始执行时间”后生效
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button> 
        <el-button size="medium" type="info" @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script> 
export default { 
  data() { 
    let price = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('指导价不能为空'));
        } else {
          const reg = /^\d+(?:\.\d{1,2})?$/
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入必须大于0且最多有两位小数的指导价'));
          }
        }
      }; 
    return {
      productInformationList:'',
      tableData:[],
      provinces:[],
      ruleForm: {
        guid:'',
        guidancePrice: '', 
        startTime:'',
      }, 
      rules: {
        guidancePrice: [
          { required: true,validator: price, trigger: 'blur' }, 
        ],
        startTime: [
          {type: 'date',required: true, message: '请输入开始执行时间', trigger: 'change' }, 
        ], 
      }, 
      textTitle:'新增指导价',
      dialogFormVisible:false,
      right: '',
    };
  },
  created() {
    // 列表 
    this.getData(false); 
  },
  methods: { 
    getData(flg) {
      let self = this; 
      self.productInformationList = ''; 
      self.api.get(`/${serverConfig.msProductService}/goods/data/get-current-guidanceprice?goodsGuid=`+self.$router.history.current.query.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {  
          self.productInformationList = res.data.data;
          self.tableData = res.data.data.guidancePriceDetailVOList.records;
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    handleSizeChange(val) {
      let self = this; 
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this; 
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this; 
      self.provinces = [];
      val.forEach(function(i){
         let item = {
              province:i.province,
              venue:i.venue
        }
        self.provinces.push(item);
        console.log(self.provinces);
      });
    },
    add(provinces){
      let self = this;  
      self.ruleForm.guidancePrice = '';
      self.ruleForm.startTime = '';
      self.dialogFormVisible = true; 
      if(provinces){
          self.provinces = [];
          let item = {
                province:provinces.province,
                venue:provinces.venue
          }
          self.provinces.push(item);
          console.log(self.provinces);
          } 
    }, 
    upDateForm(formName) {
      let self = this; 
      self.$refs[formName].validate(valid => {
        if (valid) { 
          console.log(self.provinces.length);
          if(self.provinces == null || self.provinces.length == 0){
                  self.$message.error('请勾选省份！');
                  return
          }
          let promise = {
            tenantGuid: self.$store.getters.getTenantGuid,
            goodsGuid: self.$router.history.current.query.guid,
            guidancePrice: self.ruleForm.guidancePrice,
            startTime: self.$moment(self.ruleForm.startTime).format('YYYY-MM-DD HH:mm:ss'),
            provinces: self.provinces, 
          }; 
          self.api.put(`/${serverConfig.msProductService}/goods/data/udpate-guidanceprice`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.provinces = [];
              self.dialogFormVisible = false;
              self.$message.success('新增指导价成功');
              self.getData(); 
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toLink(province){
          this.$router.push({path: "/allGuidePrices", query:{guid:this.$router.history.current.query.guid,province:province}})
    },


  },
};
</script>
